import React, { useState, useEffect } from "react";
import close from "../../assets/images/close.svg";

const DiscountPopup = ({
    show,
    onClose,
    discount,
    setDiscount,
    discountLabel,
    setDiscountLabel,
    finalTotal,
    onSubmit,
    styles,
    reference
}) => {
    const [tempDiscount, setTempDiscount] = useState(discount);
    const [tempDiscountLabel, setTempDiscountLabel] = useState(discountLabel || "");

    // Reset temp values when popup opens
    useEffect(() => {
        if (show) {
            setTempDiscount(discount);
            setTempDiscountLabel(discountLabel || "");
        }
    }, [show, discount, discountLabel]);

    if (!show) return null;

    return (
        <>
            <div className="popup-overlay"></div>

            <div className="popup-box add-new-user" ref={reference}>
                <div className="popupTop popupTopClose closePlan previewClose">
                    <img src={close} onClick={onClose} alt="Icon" />
                </div>

                <div className="popupModalTitle">Add Discount</div>

                <div className="popup-form">
                    {/* Discount Label */}
                    <input
                        type="text"
                        className={styles.input}
                        value={tempDiscountLabel}
                        onChange={(e) => setTempDiscountLabel(e.target.value)}
                        placeholder="Enter discount label"
                        style={{ marginBottom: 10 }}
                    />

                    {/* Discount Amount */}
                    <input
                        type="number"
                        min={0}
                        max={finalTotal}
                        className={styles.input}
                        value={tempDiscount}
                        onChange={(e) => setTempDiscount(e.target.value)}
                        placeholder="Enter discount (₹)"
                    />
                </div>

                <div className="popup-actions">
                    <button className="cancel-btn" onClick={onClose}>
                        Cancel
                    </button>

                    <button
                        className="save-btn"
                        onClick={() => {
                            setDiscount(Number(tempDiscount) || 0);
                            setDiscountLabel(tempDiscountLabel);
                            onSubmit();
                        }}
                    >
                        Add Discount
                    </button>
                </div>
            </div>
        </>
    );
};

export default DiscountPopup;